<mat-dialog-content class="dialog">

    <div class="tabs">
        <nav class="d-flex tabs-navegacao">

            <ng-container class="d-flex justify-space-evenly navegacao-container container">
                <a
                    class="d-flex justify-center align-center container-label"
                    [ngClass]="{'active': activeTab === 1}" role="button" tabindex="0"
                    (click)="activeTab = 1" (keydown.enter)="activeTab = 1" (keydown.space)="activeTab = 1">
                    Logs
                </a>

                <a
                    class="d-flex justify-center align-center container-label"
                    [ngClass]="{'active': activeTab === 2}" role="button" tabindex="0"
                    (click)="activeTab = 2" (keydown.enter)="activeTab = 2" (keydown.space)="activeTab = 2">
                    Logs do ERP (OMIE)
                </a>

            </ng-container>

        </nav>
    </div>

    <div class="d-flex direction-column conteudo-section section" *ngIf="activeTab === 1">
        <div class="d-flex direction-column justify-space-between align-center section-beneficiaries mt-16">

            <ng-container *ngIf="logs?.length === 0">
                <div class="empty">
                    <span class="empty-text">Não há Logs</span>
                </div>
            </ng-container>
            <ng-container *ngFor="let log of logs; let indexLog = index">
                <div class="card-log">
                    <div class="d-flex card-conteudo conteudo">
                        <span>{{log.Event}}</span>
                    </div>
                </div>
            </ng-container>
        </div>
    </div>

    <div class="d-flex direction-column conteudo-section section mt-16" *ngIf="activeTab === 2">


        <div class="empty mt-16" *ngIf="logSap?.length === 0">
            <span class="empty-text">Não há Logs</span>
        </div>

        <div *ngIf="logSap?.length !== 0">
            <app-header-list [headerItems]=" sapHeaderList" class=""></app-header-list>
            <ng-container *ngFor="let log of logSap; let i = index">
                <div class="container-content content d-flex align-center justify-space-between">
                    <div class="content-card card-sap d-flex align-center justify-space-around">

                        <div class="card-data data flex-1">
                            <span class="">{{ log.DataIntegracaoFormatada || "-" }}</span>
                        </div>

                        <div class="card-data data flex-1">
                            <span class="">{{ log.DataProcessamento || "-" }}</span>
                        </div>

                        <div class="card-data data flex-1">
                            <span class="">{{ log.CodVenda || "-" }}</span>
                        </div>

                        <div class="card-data data flex-1">
                            <span class="">{{ log.TipoRegistro || "-" }}</span>
                        </div>

                        <div class="card-data data flex-1">
                            <span class="">{{ log.CodProcessamento || "-" }}</span>
                        </div>

                        <div class="card-data data flex-1">
                            <span class="">{{log.SucessoProcessamento ? 'SIM' : 'NÃO'}}</span>
                        </div>

                        <div class="card-data data flex-1">
                            <span class="">{{ log.DescricaoErroProcessamento || "-" }}</span>
                        </div>

                        <div class="card-data data flex-1">
                            <span class="">{{ log.RPS || "-" }}</span>
                        </div>

                        <div class="card-data data flex-1">
                            <span class="">{{ log.NumeroNfe || "-" }}</span>
                        </div>

                        <div class="card-data data flex-1">
                            <span class="">{{log.ValorTotal | currency : "BRL" || "-"}}</span>
                        </div>

                    </div>
                </div>
            </ng-container>

        </div>
    </div>

    <div class="d-flex align-center justify-center mt-32">
        <button class="close ui-btn ui-btn--primary" (click)="close()">
            Fechar
        </button>
    </div>
</mat-dialog-content>
